import React from 'react';
import ReactDOM from 'react-dom';
import './styles/styles.css';
import './styles/banner.css';
import './global/fonts/typography.css';

import App from './App';

ReactDOM.render(
  <App />,
  document.getElementById('root'),
);
